import get from "lodash-es/get";
import has from "lodash-es/has";
import keys from "lodash-es/keys";
import set from "lodash-es/set";
import type { useToast as toastFn } from "vue-toastification";
import * as vueToastification from "vue-toastification";

type ToastFn = typeof toastFn;
export const useToast = (...args: Parameters<ToastFn>) => {
  let toastFn: ToastFn | undefined;

  if (!toastFn && has(vueToastification, "default.useToast")) {
    toastFn = get(vueToastification, "default.useToast", undefined) as
      | ToastFn
      | undefined;
  }

  if (!toastFn && has(vueToastification, "useToast")) {
    toastFn = get(vueToastification, "useToast", undefined) as
      | ToastFn
      | undefined;
  }

  type ToastFnReturnType = ReturnType<ToastFn>;
  const propFn = (
    type: keyof ToastFnReturnType,
    toastFnResp: ToastFnReturnType,
  ) => {
    if (type === "error") {
      return ((message: string, ...otherOptions) => {
        if (message === "messages_unauthorized") {
          return "";
        }

        return toastFnResp[type](message, ...otherOptions);
      }) as ToastFnReturnType["error"];
    }

    return toastFnResp[type];
  };

  const builtToast = ((...args: Parameters<ToastFn>) => {
    if (!toastFn) {
      return;
    }

    const toastFnResp = toastFn(...args);
    return keys(toastFnResp).reduce((returnVal, type) => {
      const key = type as keyof ToastFnReturnType;
      set(returnVal, key, propFn(key, toastFnResp));
      return returnVal;
    }, {} as ToastFnReturnType);
  }) as ToastFn;

  return builtToast(...args);
};
